/*
 * Capable Health API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0.3
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 *
 * Swagger Codegen version: 3.0.72
 *
 * Do not edit the class manually.
 *
 */
import ApiClient from '../ApiClient';
import IntegrationsshopifyShopifyIntegration from './IntegrationsshopifyShopifyIntegration';

/**
 * The IntegrationsShopifyBody model module.
 * @module model/IntegrationsShopifyBody
 * @version v0.3
 */
export default class IntegrationsShopifyBody {
  /**
   * Constructs a new <code>IntegrationsShopifyBody</code>.
   * @alias module:model/IntegrationsShopifyBody
   * @class
   */
  constructor() {
  }

  /**
   * Constructs a <code>IntegrationsShopifyBody</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/IntegrationsShopifyBody} obj Optional instance to populate.
   * @return {module:model/IntegrationsShopifyBody} The populated <code>IntegrationsShopifyBody</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new IntegrationsShopifyBody();
      if (data.hasOwnProperty('shopify_integration'))
        obj.shopifyIntegration = IntegrationsshopifyShopifyIntegration.constructFromObject(data['shopify_integration']);
    }
    return obj;
  }
}

/**
 * @member {module:model/IntegrationsshopifyShopifyIntegration} shopifyIntegration
 */
IntegrationsShopifyBody.prototype.shopifyIntegration = undefined;

